export default __webpack_public_path__ + "static/media/Horne Houston 2.14a40024.jpg";